import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Moment} from './moment/moment';
import {DataSharing} from './data.sharing';

@Injectable()
export class HttpRequests {
    _content_types = {
        json: 'application/json',
        undefined: 'undefined',
        form: 'application/x-www-form-urlencoded; charset=utf-8',
    };

    constructor(public http: HttpClient) {
    }

    HttpGet(url, content_type = 'form'): Observable<any> {
        return this.http.get(url, {headers: this.SetHeader(content_type)});
    }

    HttpPost(url, data, content_type = 'form'): Observable<any> {
        return this.http.post(url, data, {headers: this.SetHeader(content_type)});
    }

    HttpPostFile(url, data, content_type = 'form'): Observable<any> {
        return this.http.post(url, data, {headers: this.SetFileHeader(content_type)});
    }

    HttpPut(url, data, content_type = 'form'): Observable<any> {
        return this.http.put(url, data, {headers: this.SetHeader(content_type)});
    }

    HttpPatch(url, data, content_type = 'form'): Observable<any> {
        return this.http.patch(url, data, {headers: this.SetHeader(content_type)});
    }

    HttpDelete(url, content_type = 'form'): Observable<any> {
        return this.http.delete(url, {headers: this.SetHeader(content_type)});
    }

    FileUpload(url, data): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + DataSharing.retrieve('token')
        });
        return this.http.post(url, data, {headers: headers});
    }

    GetContentType(type = 'form') {
        return this._content_types[type];
    }

    SetHeader(content_type) {
        const pageToken = DataSharing.getPageToken() ? DataSharing.getPageToken() : '';
        const headers = {
            'Content-Type': this.GetContentType(content_type),
            'time-zone': Moment.GetTimeZone(),
            Authorization: 'Bearer ' + DataSharing.getToken(),
            'Page-Token': pageToken,
        };
        return new HttpHeaders(headers);
    }

    SetFileHeader(content_type) {
        const pageToken = DataSharing.getPageToken() ? DataSharing.getPageToken() : '';
        const headers = {
            // 'Content-Type': this.GetContentType(content_type),
            'time-zone': Moment.GetTimeZone(),
            Authorization: 'Bearer ' + DataSharing.getToken(),
            'Page-Token': pageToken,
        };
        return new HttpHeaders(headers);
    }
}
